import React from 'react';

import {ActionCreatorWithPayload} from '@reduxjs/toolkit';

enum EListState {
  UNINITIALIZED = 'UNINITIALIZED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

type TListState = keyof typeof EListState;

const PAGE_SIZE = 15;
const DEFAULT_INDIVIDUAL_FILTERS = ['filter'];

type TFiltersConfig<T> = {
  defaultFilters?: T;
  selector?: (state: TRootState) => T;
  action?: ActionCreatorWithPayload<T>;
  validate?: (filters: T) => boolean;
  individualFilters?: string[];
};

type TFilters<T> = {
  payload: T;
  data: T;
  setFilters: React.Dispatch<React.SetStateAction<T>>;
  reset: TEmptyFunction;
  valid: boolean;
};

export {EListState, PAGE_SIZE, DEFAULT_INDIVIDUAL_FILTERS};
export type {TListState, TFiltersConfig, TFilters};
